import "core-js/modules/es.parse-int.js";
var IS_FOCUSABLE_ATTRIBUTE = 'data-is-focusable';

/** Determines if the browser can tabbed to. */
export function isElementTabbable(element, checkTabIndex) {
  // If this element is null or is disabled, it is not considered tabbable.
  if (!element || element.disabled) {
    return false;
  }
  var tabIndex = 0;
  var tabIndexAttributeValue = null;
  if (element && element.getAttribute) {
    tabIndexAttributeValue = element.getAttribute('tabIndex');
    if (tabIndexAttributeValue) {
      tabIndex = parseInt(tabIndexAttributeValue, 10);
    }
  }
  var isFocusableAttribute = element.getAttribute ? element.getAttribute(IS_FOCUSABLE_ATTRIBUTE) : null;
  var isTabIndexSet = tabIndexAttributeValue !== null && tabIndex >= 0;
  var result = !!element && isFocusableAttribute !== 'false' && (element.tagName === 'A' || element.tagName === 'BUTTON' || element.tagName === 'INPUT' || element.tagName === 'TEXTAREA' || element.tagName === 'SELECT' || isFocusableAttribute === 'true' || isTabIndexSet);
  return checkTabIndex ? tabIndex !== -1 && result : result;
}

/** This could probably be improved by adding a container param to limit upward searching */
export function getTabbableParent(element, checkTabIndex) {
  var parentElement = element.parentElement;
  if (parentElement) {
    if (isElementTabbable(parentElement, checkTabIndex)) {
      return parentElement;
    }
    return getTabbableParent(parentElement, checkTabIndex);
  }
  return null;
}